import React from 'react';
import { ModalAlert } from '@getpingback/realeza';

const DeleteModal = ({ isOpen, onClose, onDelete, title, message }) => {
  return (
    <ModalAlert
      type="danger"
      title={title}
      content={message}
      isOpen={isOpen}
      onClose={onClose}
      onActionPrimary={onDelete}
      actionPrimaryText="Delete"
      onActionSecondary={onClose}
      actionSecondaryText="Cancel"
    />
  );
};

export default DeleteModal;
